import React, { useEffect, useState, useContext, useRef } from 'react';
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonList, IonItem, IonicSlides, IonText, IonIcon, IonPopover } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import '../css/zPublic.css';

import {ProService_Homepage} from '../components/Homepage_proService';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { GPSC_Component } from './Merchant_GeoLocation';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component

import { checkmarkCircleOutline } from 'ionicons/icons';


export function Home_ProfessionalServicesList (props) 
{


    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [viewMerchantList_professionalServices, setViewMerchantList_professionalServices] = useState([]);


    let [companyID, setCompanyID] = useState(null);
    let [companySchema, setCompanySchema] = useState(null);
    let [companyName, setCompanyName] = useState(null);
    let [companyAddressNumber, setCompanyAddressNumber] = useState(false);
    let [companyStreetName, setCompanyStreetName] = useState(false);
    let [companyCity, setCompanyCity] = useState(false);
    let [companyCityDistrict, setCompanyCityDistrict] = useState(false);
    let [companyPhoneNumber, setCompanyPhoneNumber] = useState(false);
    let [companyEmail, setCompanyEmail] = useState(false);
    let [customerRating, setCustomerRating] = useState('0.00000');
    let [companyLatitude, setCompanyLatitude] = useState(null);
    let [companyLongitude, setCompanyLongitude] = useState(null);
    let [proServiceHompageModal, setProServiceHomepageModal] = useState(false);
    let [mtnCompanyPhoneNumber, setMtnCompanyPhoneNumber] = useState(false);

    let [merchantID, setMerchantID] = useState(null);
    let [merchantName, setMerchantname] = useState(null);
    let [merchantMomoNumber, setMerchantMomoNumber] = useState(null);
    let [merchantUpload_ghanaID, setmerchantUpload_ghanaID] = useState(null);
    let [merchantUpload_businessRegistrationID, setMerchantUpload_businessRegistrationID] = useState(null);
    let [merchantAddress, setMerchantAddress] = useState(null);
    let [merchantLatitude, setMerchantLatitude] = useState(null);
    let [merchantLongitude, setMerchantLongitude] = useState(null);
    let [merchantUpload_companyMainImage, setMerchantUpload_companyMainImage] = useState(null);

    let [viewIonPopover, setViewIonPopover] = useState(false);

    const merchantBio_info = 'NULL' || '' || undefined;
    const isEmptyBio = (value) => {
    return value === undefined || value === null || value === '' || value === 'NULL';
    };

    useEffect(() => {
        

        setViewMerchantList_professionalServices([]);


            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                 },
                body: JSON.stringify({
                    Tracker: "0002_pro_service",
    
                })            }
    
            //alert('In ghanaverifiedApp - HotelList UseEffect');

            fetch(baseURL+'merchants_argsApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                for(let rowNum = 0; rowNum < rows.length - 1; ++rowNum)
                {
                    let cols_spit = rows[rowNum].split('#');
                    let cols = cols_spit[0].split('|');
                    let cols_1 = cols_spit[1].split('|');

                    setViewMerchantList_professionalServices((prevViewMerchantList_proServices) => {
                        return prevViewMerchantList_proServices.concat({
                            companyAcctID: cols[0],
                            companyName: cols[1],
                            companyAddressNumber: cols[2],
                            streetName: cols[3],
                            city: cols[4],
                            cityDistrict: cols[5],
                            companyPhoneNumber: cols[6],
                            companyEmail: cols[7],
                            companyImage: cols[8],
                            companySchema: cols[9],
                            customerRating: cols[10],
                            latitude: cols[11],
                            longitude: cols[12],
                            mtnCompanyPhoneNumber: cols[13],
                            merchantID: cols_1[0], 
                            merchantName: cols_1[1],
                            merchantMomoNumber: cols_1[2],
                            merchantUpload_ghanaID: cols_1[3],
                            merchantUpload_businessRegistrationID: cols_1[4],
                            merchantAddress: cols_1[5],
                            verified_latitude: cols_1[6],
                            verified_longitude: cols_1[7],
                            merchantUpload_companyMainImage: cols_1[8],
                            companyShowcase: cols_1[9],
                            date_logged: cols_1[10],
                            onboardingStatus: cols_1[11],
                        })

                    });
                }

                props.confirmComplete();
            })
    }, []);


    function zPub_selectMerchantID(e)
    {
        //e.preventdefault();
        // alert("in Z");
        // alert(e);
        // alert(e[1]);
        // alert(e[2]);
        //props.merchantIDB(e);
        //authMerchant_objects.changeAccountID(e[1]);
        setCompanyID(e[1]);
        setCompanySchema(e[2]);
        setCompanyName(e[3]);
        setCompanyAddressNumber(e[4]);
        setCompanyStreetName(e[5]);
        setCompanyCity(e[6]);
        setCompanyCityDistrict(e[7]);
        setCompanyEmail(e[8]);
        setCompanyPhoneNumber(e[9]);
        setCustomerRating(e[10]);
        setCompanyLatitude(e[11]);
        setCompanyLongitude(e[12]);
        setMtnCompanyPhoneNumber(e[13]);

        setProServiceHomepageModal(e[0]);

    }

    function setViewIonPopoverHandler(event)
    {

        setMerchantID(event[0]);
        setMerchantname(event[1]);
        setMerchantMomoNumber(event[2]);
        setmerchantUpload_ghanaID(event[3]);
        setMerchantUpload_businessRegistrationID(event[4]);
        setMerchantAddress(event[5]);
        setMerchantLatitude(event[6]);
        setMerchantLongitude(event[7]);
        setMerchantUpload_companyMainImage(event[8]);
        setViewIonPopover(true);
    }
        return (
            <React.Fragment>

                {viewMerchantList_professionalServices.length == 0 && (
                <div className='zList_companyImage_list'>
                    <IonCard className='card_merchantList'>
                    <div className='zList_img'>
                        <div className="dot-loader">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        </div>
                    </div>
                    </IonCard>
                </div>
                )}


                            {viewMerchantList_professionalServices.length > 0 && (
                                <div className="zList_companyImage_list">
                                    {viewIonPopover && (
                                    <IonPopover
                                        isOpen={viewIonPopover}
                                        onDidDismiss={() => setViewIonPopover(false)}
                                        className="custom-popover"
                                    >
                                        <IonGrid className="custom-popover-grid">
                                        {/* Business Owner */}
                                        <IonRow>
                                            <IonCol size="6">
                                            <IonText style={{ color: 'black', fontSize: '.5em' }}>
                                                Business Owner
                                            </IonText>
                                            </IonCol>
                                            <IonCol size="6">
                                            {(() => {
                                                const ownerVerified =
                                                !isEmptyBio(merchantName) &&
                                                !isEmptyBio(merchantMomoNumber) &&
                                                !isEmptyBio(merchantUpload_companyMainImage);

                                                return (
                                                <IonText
                                                    style={{
                                                    color: ownerVerified ? 'green' : 'red',
                                                    fontSize: '.5em',
                                                    }}
                                                >
                                                    {ownerVerified ? 'Verified' : 'Not Verified'}
                                                </IonText>
                                                );
                                            })()}
                                            </IonCol>
                                        </IonRow>

                                        {/* Ghana ID */}
                                        <IonRow>
                                            <IonCol size="6">
                                            <IonText style={{ color: 'black', fontSize: '.5em' }}>
                                                Ghana ID
                                            </IonText>
                                            </IonCol>
                                            <IonCol size="6">
                                            {(() => {
                                                const ghanaIdVerified = !isEmptyBio(merchantUpload_ghanaID);
                                                return (
                                                <IonText
                                                    style={{
                                                    color: ghanaIdVerified ? 'green' : 'red',
                                                    fontSize: '.5em',
                                                    }}
                                                >
                                                    {ghanaIdVerified ? 'Verified' : 'Not Verified'}
                                                </IonText>
                                                );
                                            })()}
                                            </IonCol>
                                        </IonRow>

                                        {/* Business Location */}
                                        <IonRow>
                                            <IonCol size="6">
                                            <IonText style={{ color: 'black', fontSize: '.5em' }}>
                                                Business Location
                                            </IonText>
                                            </IonCol>
                                            <IonCol size="6">
                                            {(() => {
                                                const locationVerified =
                                                !isEmptyBio(merchantAddress) &&
                                                !isEmptyBio(merchantLatitude) &&
                                                !isEmptyBio(merchantLongitude);

                                                return (
                                                <IonText
                                                    style={{
                                                    color: locationVerified ? 'green' : 'red',
                                                    fontSize: '.5em',
                                                    }}
                                                >
                                                    {locationVerified ? 'Verified' : 'Not Verified'}
                                                </IonText>
                                                );
                                            })()}
                                            </IonCol>
                                        </IonRow>

                                        {/* Business Certificate */}
                                        <IonRow>
                                            <IonCol size="6">
                                            <IonText style={{ color: 'black', fontSize: '.5em' }}>
                                                Business Certificate
                                            </IonText>
                                            </IonCol>
                                            <IonCol size="6">
                                            {(() => {
                                                const certVerified =
                                                !isEmptyBio(merchantUpload_businessRegistrationID);

                                                return (
                                                <IonText
                                                    style={{
                                                    color: certVerified ? 'green' : 'red',
                                                    fontSize: '.5em',
                                                    }}
                                                >
                                                    {certVerified ? 'Verified' : 'Not Verified'}
                                                </IonText>
                                                );
                                            })()}
                                            </IonCol>
                                        </IonRow>

                                        <IonRow>
                                            <IonCol size="12">
                                            <IonButton
                                                onClick={(e) => {
                                                e.stopPropagation();
                                                setViewIonPopover(false);
                                                }}
                                            >
                                                close
                                            </IonButton>
                                            </IonCol>
                                        </IonRow>
                                        </IonGrid>
                                    </IonPopover>
                                    )}

                                    {viewMerchantList_professionalServices.map((detailData) => {
                                    // Compute verification status for this merchant
                                    const allFieldsFilled =
                                        !isEmptyBio(detailData.merchantName) &&
                                        !isEmptyBio(detailData.merchantMomoNumber) &&
                                        !isEmptyBio(detailData.merchantUpload_companyMainImage) &&
                                        !isEmptyBio(detailData.merchantUpload_ghanaID) &&
                                        !isEmptyBio(detailData.merchantUpload_businessRegistrationID) &&
                                        !isEmptyBio(detailData.merchantAddress) &&
                                        !isEmptyBio(detailData.verified_latitude) &&
                                        !isEmptyBio(detailData.verified_longitude);

                                    let missingCount = 0;

                                    if (isEmptyBio(detailData.merchantName) || isEmptyBio(detailData.merchantMomoNumber) || isEmptyBio(detailData.merchantUpload_companyMainImage)) missingCount++;
                                    if (isEmptyBio(detailData.merchantAddress) || isEmptyBio(detailData.verified_latitude) || isEmptyBio(detailData.verified_longitude)) missingCount++;
                                    if (isEmptyBio(detailData.merchantUpload_ghanaID)) missingCount++;
                                    if (isEmptyBio(detailData.merchantUpload_businessRegistrationID)) missingCount++;
                                    
                                    const mostlyMissing = missingCount >= 3;

                                    let iconColor = 'goldenrod';
                                    if (allFieldsFilled) iconColor = 'green';
                                    else if (mostlyMissing) iconColor = 'red';

                                    return (
                                        <IonGrid key={detailData.companyAcctID}>
                                        <IonRow>
                                            <IonCol size="12" className="zPub_list_gridCol_title">
                                            {detailData.companyName}

                                            <IonIcon
                                                icon={checkmarkCircleOutline}
                                                style={{ color: iconColor, fontSize: '1.5em' }}
                                                onClick={(e) => {
                                                e.stopPropagation();
                                                setViewIonPopoverHandler([
                                                    detailData.merchantID,
                                                    detailData.merchantName,
                                                    detailData.merchantMomoNumber,
                                                    detailData.merchantUpload_ghanaID,
                                                    detailData.merchantUpload_businessRegistrationID,
                                                    detailData.merchantAddress,
                                                    detailData.verified_latitude,
                                                    detailData.verified_longitude,
                                                    detailData.merchantUpload_companyMainImage,
                                                ]);
                                                }}
                                            />
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol>
                                                <IonCard className='card_merchantList'>
                                                    <IonButton className='hidden_button' key={detailData.companyAcctID} fill='clear' onClick={ () => zPub_selectMerchantID([true, detailData.companyAcctID, detailData.companySchema, detailData.companyName, detailData.companyAddressNumber, detailData.streetName, detailData.city, detailData.cityDistrict, detailData.companyEmail, detailData.companyPhoneNumber, detailData.customerRating, detailData.latitude, detailData.longitude, detailData.mtnCompanyPhoneNumber]) } >
                        
                                                        <div className='zList_companyImage_list_div'>
                        
                                                            {/* <CachedImage  
                                                                imageUrl={detailData.companyImage}
                                                                fileName={detailData.companyImage} 
                                                                className="zList_companyImage_list_inside"
                                                                alt="Example Cached Image"
                                                                        ></CachedImage>*/}

                                                                <IonImg className="zList_companyImage_list_inside" src={detailData.companyImage} />    
                                                        </div>

                                                        {/*<IonGrid className='gridMain_merchantList_bottom'>
                                                            <IonRow >
                                                                <IonCol className='zPub_gridCol'>{detailData.customerRating}</IonCol>
                                                            </IonRow>
                                                            </IonGrid>*/}
                                                    </IonButton>
                                                </IonCard>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol>
                                            {((detailData.latitude != undefined && detailData.latitude != merchantBio_info) && (detailData.longitude != undefined && detailData.longitude != merchantBio_info)) && <GPSC_Component data={{
                                                    companyLatitude: detailData.latitude, 
                                                    companyLongitude: detailData.longitude,
                                                    }}></GPSC_Component>}
                                            </IonCol>
                                        </IonRow>  
                                    </IonGrid>
                                );
                            })}
                </div>)} 
                
                {proServiceHompageModal == true && <ProService_Homepage openModal={proServiceHompageModal} closeModal={() => setProServiceHomepageModal(false)} data={{
                    companyId: companyID, 
                    companySchema: companySchema, 
                    companyName: companyName,
                    companyAddressNumber: companyAddressNumber,
                    companyStreetName: companyStreetName,
                    companyCity: companyCity,
                    companyCityDistrict: companyCityDistrict,
                    companyEmail: companyEmail,
                    companyPhoneNumber: companyPhoneNumber,
                    customerRating: customerRating,
                    mtnCompanyPhoneNumber: mtnCompanyPhoneNumber,

                    }}></ProService_Homepage>}

            </React.Fragment>
        )
}